
(function () {
  function setupPhotoUploads() {
    document.querySelectorAll('.dropslot').forEach(box => {
      const input = box.querySelector('input[type="file"]');
      const zone = box.querySelector('.dropslot__zone');
      const dropText = box.querySelector('.dropslot__drop');

      if (!input || input.dataset.portraitChecker) return;
      input.dataset.portraitChecker = 'true';

      // Hide the drag-and-drop message
      if (dropText) {
        dropText.style.display = 'none';
      }

      // Disable drag-and-drop uploads
      if (zone) {
        ['dragenter', 'dragover', 'drop'].forEach(type => {
          zone.addEventListener(type, event => {
            event.preventDefault();
            event.stopImmediatePropagation();
          }, true);
        });
      }

      // Check photo orientation
      let approved = false;

      input.addEventListener('change', function(event) {
        if (approved) {
          approved = false;
          return;
        }

        const file = input.files[0];
        if (!file) return;

        event.stopImmediatePropagation();

        const url = URL.createObjectURL(file);
        const image = new Image();

        image.onload = function() {
          URL.revokeObjectURL(url);

          if (image.width >= image.height) {
            alert(
              'Please upload a VERTICAL photo. Horizontal and square photos will not fit our air fresheners.'
            );
            input.value = '';
          } else {
            approved = true;
            input.dispatchEvent(
              new Event('change', { bubbles: true })
            );
          }
        };

        image.onerror = function() {
          URL.revokeObjectURL(url);
          alert('Unable to check this photo. Please try another.');
          input.value = '';
        };

        image.src = url;
      }, true);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupPhotoUploads);
  } else {
    setupPhotoUploads();
  }
})();
